import TransactionsList from '../transactions/TransactionsList';
import { convertPaymentsToTransactions } from '../../helpers/payments';
import { PaymentsGroup } from '../../types/payments';
import useCashDiscount from '../../hooks/payments/useCashDiscount';

export default function CheckoutTransactionsSection({
  paymentsGroup,
}: {
  paymentsGroup: PaymentsGroup;
}) {
  const { cashDiscountEnabled: businessCashDiscountEnabled } =
    useCashDiscount();
  const sortedTransactions = convertPaymentsToTransactions(
    paymentsGroup?.payments ?? [],
    { paymentsGroup, businessCashDiscountEnabled },
  );

  return <TransactionsList transactions={sortedTransactions} />;
}
